export default "__VITE_ASSET__D8W66uoD__"